<template>
  <div class="group-moveable">
    <!--Group Header -->
    <div class="row no-gutters shadow-sm bg-sidebar text-white">
      <div class="col-md-12">
        <div class="groupName pl-2">
          <div class="float-left pointer" @click="toggleExpansion(group)">
                        <span class="badge" :style="'background-color: ' + group.color">
                            &nbsp;&nbsp;
                        </span>
            <span v-if="group.name !== ''">
                            {{ group.name }}
                        </span>
            <span class="pl-1" v-else>
                                <i>{{ $t('UI_INSTANCE_MEMBER_GROUP_UNNAMED') }}</i>
                        </span>
          </div>


          <span class="float-right pr-1" v-if="editModeEnabled">
                        <i class="fa fa-edit text-warning ml-2 pointer" :key="1" @click="openEditGroupModal(group)"></i>
                        <i class="fa fa-trash text-danger ml-2 pointer" :key="2" @click="deleteGroup(group.id)"></i>
                    </span>
          <span class="clearfix"></span>
        </div>
      </div>
    </div>

    <!-- Move Group Bar -->
    <div class="card bg-light" v-if="editModeEnabled">
      <div class="row no-gutters">
        <div class="col-md-12 text-center">
          <i @click="moveGroup('up', group)" :class="getArrowTextColor('up', group)"
             class="fa fa-arrow-up pointer hoverColorChange"></i>
          <i @click="moveGroup('down', group)" :class="getArrowTextColor('down', group)"
             class="fa fa-arrow-down pointer hoverColorChange ml-2"></i>
          <i @click="moveGroup('left', group)" :class="getArrowTextColor('left', group)"
             class="fa fa-arrow-left pointer hoverColorChange ml-2"></i>
          <i @click="moveGroup('right', group)" :class="getArrowTextColor('right', group)"
             class="fa fa-arrow-right pointer hoverColorChange ml-2"></i>
        </div>
      </div>
    </div>

    <!-- Member List -->
    <transition-group tag="div" name="slide" class="card" v-if="editModeEnabled">
      <!-- Edit Mode activated: Enable Move -->
      <Container group-name="groupContainer" @drop="(dropResult) => onDrop(dropResult, group)" :get-child-payload="(index) => getChildPayload(index, group)" :key="group.id">
        <!-- Member -->
        <Draggable class="row no-gutters pointer" v-for="member in group.members" :key="member.id" v-show="!isExpanded(group)" @mouseover="hoveredMember = member" @mouseleave="hoveredMember = null">
          <div class="col-md-12" :class="getMemberBackgroundClass(member, group)">
            <span class="badge ml-2" :style="'background-color: ' + group.color_light">&nbsp;&nbsp;</span>
            <span>&nbsp; {{ member.name }}</span>
            <span class="float-right pr-1">
              <InstanceMemberEdit :member="member" :group="group"/>
              <InstanceMemberDelete :member="member" :group="group"/>
            </span>
          </div>
        </Draggable>
      </Container>

      <InstanceMemberAdd :group="group" key="memberadd"/>

    </transition-group>

    <transition-group  tag="div" name="slide" class="card" v-else>
      <!-- No Edit Mode-->
      <div class="row no-gutters" :class="{'pointer': $store.getters.getSelectedEntryId !== null}" v-for="member in group.members" :key="member.id" v-show="!isExpanded(group)" @mouseover="hoveredMember = member" @mouseleave="hoveredMember = null">
        <div class="col-md-12" :class="getMemberBackgroundClass(member, group)" @dblclick="addChapterWithMember(member, group)">
          <span class="badge ml-2" :style="'background-color: ' + group.color_light">&nbsp;&nbsp;</span>
          <span>&nbsp; {{ member.name }}</span>
        </div>
      </div>
    </transition-group>

    <!-- Edit Group Modal -->
    <sweet-modal :title="$t('UI_INSTANCE_MEMBER_GROUP_EDIT')" ref="editGroupModal" v-on:close="resetGroupToEdit">
      <div class="form-group">
        <label for="title">{{ $t('UI_INSTANCE_MEMBER_GROUP_TITLE') }}</label>
        <input type="text" id="title" v-model="groupToEdit.name"
               :placeholder="$t('UI_INSTANCE_MEMBER_GROUP_TITLE')" class="form-control">
      </div>

      <div class="form-group">
        <label for="color">{{ $t('UI_INSTANCE_MEMBER_GROUP_COLOR') }}</label>
        <swatches v-model="groupToEdit.color" id="color" inline></swatches>
      </div>


      <div slot="button">
        <button class="btn btn-primary" @click="editGroup">
          {{ $t('UI_MODAL_BUTTON_SAVE') }}
        </button>
        <button class="btn btn-secondary ml-1" @click="$refs.editGroupModal.close()">
          {{ $t('UI_MODAL_BUTTON_CLOSE') }}
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
	import { SweetModal } from 'sweet-modal-vue';
	import { Draggable, Container } from 'vue-smooth-dnd';
	import Swatches from 'vue-swatches';
	import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';
	import InstanceMemberAdd from './MemberAdd';
	import InstanceMemberEdit from './MemberEdit';
	import InstanceMemberDelete from './MemberDelete';

	const InstanceGroupRepository = RepositoryFactory.get('instanceGroups');
	const InstanceRepository = RepositoryFactory.get('instances');
	const ChapterLiveRepository = RepositoryFactory.get('chaptersLive');
	const InstanceMemberRepository = RepositoryFactory.get('instanceMembers');
	const ChapterRepository = RepositoryFactory.get('chapters');

	export default {
		name: 'GroupCard',
		props: ['group'],
		components: {
			Draggable,
			Container,
			InstanceMemberDelete,
			InstanceMemberEdit,
			InstanceMemberAdd,
			Swatches,
			SweetModal
		},
		data() {
			return {
				hoveredMember: null,
				expandedList: [],
				groupToEdit: {
					id: null,
					name: '',
					color: '',
				},
			};
		},
		methods: {
			/*
        MEMBER MOVER
      */

			getChildPayload(index) {
				return this.group.members.find(member => member.order === index);
			},

			async onDrop(dropResult, group) {
				const { removedIndex, addedIndex, payload } = dropResult;
				const member = payload;

				let moving = this.$parent.moving;

				if (removedIndex === null && addedIndex === null) {
					return false;
				}

				if (removedIndex !== null) {
					// This is the source container
					moving.sourceGroup = group;
				}
				if (addedIndex !== null) {
					// this is the target container
					moving.targetGroup = group;
					moving.targetPosition = addedIndex;
				}

				// if source & Target groups are set
				if (moving.sourceGroup !== null && moving.targetGroup !== null) {
					// Check the Payload. Payload should contain the member object being moved.
					if (member !== undefined && member !== null) {
						this.isLoading = true;
						await InstanceMemberRepository.moveMember(moving.sourceGroup.id, moving.targetGroup.id, member.id, moving.targetPosition)
										.then(() => {
											// Reset Selections
											moving.sourceGroup = null;
											moving.targetGroup = null;
											moving.targetPosition = null;

											InstanceRepository.refetchActive(false);
										});

					}
				}
			},

			/**
			 * Inserts a new Chapter containing a member.
			 */
			addChapterWithMember(member, group) {
				if (this.$store.getters.editModeEnabled) {
					return false;
				}

				// The user has selected an entry -> Replace instead of add
				if (this.$store.getters.getSelectedChapterId !== null && this.$store.getters.getSelectedEntryId !== null) {
					return this.replaceSelectedEntryWithMember(member, group);
				}

				if (!this.$store.getters.instanceInLiveMode) {
					return false;
				}

				ChapterLiveRepository.insertChapterWithMemberAndGroup(member.id, group.id)
								.then(() => {
									InstanceRepository.refetchActive(false);
								});
			},

			/**
			 * Replaces the selected entry with the specified member.
			 */
			replaceSelectedEntryWithMember(member, group) {
				if (this.$store.getters.editModeEnabled) {
					return false;
				}

				if (this.$store.getters.getSelectedChapterId === null || this.$store.getters.getSelectedEntryId === null) {
					return false;
				}

				ChapterRepository.appendEntryWithMember(this.$store.getters.getSelectedChapterId, this.$store.getters.getSelectedEntryId, group.id, member.id)
								.then(() => {
									InstanceRepository.refetchActive(false);
								});
			},

			resetGroupToEdit() {
				this.groupToEdit = {
					id: null,
					name: '',
					color: '',
				};
			},
			async editGroup() {
				const grp = this.groupToEdit;
				await InstanceGroupRepository.modify(grp.id, grp.name, grp.color)
								.then(() => {
									this.$snotify.info(this.$t('UI_INSTANCE_MEMBER_GROUP_MODIFIED', { name: grp.name }));
									InstanceRepository.refetchActive(false);
									this.$refs.editGroupModal.close();
								});
			},
			openEditGroupModal(group) {
				this.groupToEdit = {
					id: group.id,
					name: group.name,
					color: group.color,
				};
				this.$refs.editGroupModal.open();
			},
			async deleteGroup(id) {
				await InstanceGroupRepository.delete(id)
								.then(() => InstanceRepository.refetchActive(false));
			},
			isExpanded(group) {
				return this.expandedList.includes(group.id);
			},
			toggleExpansion(group) {
				if (this.isExpanded(group)) {
					const index = this.expandedList.indexOf(group.id);
					if (index > -1) {
						this.expandedList.splice(index);
					}
				} else {
					this.expandedList.push(group.id);
				}
			},
			getMemberBackgroundClass(member, group) {
				// Disable Hover BG Color in Edit Mode
				if (this.editModeEnabled) {
					return member.order % 2 ? 'entry-grey' : '';
				}

				if (member.order % 2) {
					return this.hoveredMember === member ? 'hoveredMember pointer' : 'entry-grey';
				}
				return this.hoveredMember === member ? 'hoveredMember pointer' : '';
			},

			/**
			 * ======= ARROW MOVE ACTIONS ==========
			 */
			moveGroup(direction, group) {
				if (!this.canMoveGroupInDirection(direction, group)) {
					return false;
				}

				switch (direction) {
					case 'up':
						return InstanceGroupRepository.moveUp(group)
										.then(() => InstanceRepository.refetchActive(false));
					case 'down':
						return InstanceGroupRepository.moveDown(group)
										.then(() => InstanceRepository.refetchActive(false));
					case 'left':
						return InstanceGroupRepository.moveLeft(group)
										.then(() => InstanceRepository.refetchActive(false));
					case 'right':
						return InstanceGroupRepository.moveRight(group)
										.then(() => InstanceRepository.refetchActive(false));
					default:
						return false;
				}
			},

			canMoveGroupInDirection(direction, group) {
				switch (direction) {
					case 'up':
						return group.order !== 0;
					case 'down':
						return group.order !== this.getHighestSortForColumn(group.column);
					case 'left':
						return group.column !== 0;
					case 'right':
						return group.column !== 1;
					default:
						return 'text-dark';
				}
			},

			// Determines the Color for the arrow
			getArrowTextColor(direction, group) {
				return this.canMoveGroupInDirection(direction, group) ? 'text-dark' : 'text-grey';
			},
			// Returns the Highest Sort available for the column
			getHighestSortForColumn(column) {
				const groups = this.$store.getters.activeInstanceData.members.filter(group => group.column === column);

				const sort = groups.map(group => group.order)
								.sort((a, b) => a - b);
				return Math.max(...sort);
			},
			/**
			 * ======= ARROW MOVE END ==========
			 */

		},
		computed: {
			editModeEnabled() {
				return this.$store.getters.instanceGroupEditEnabled;
			},
		},
	};
</script>

<style scoped>
  .groupName {
    font-size: 22px;
    font-weight: 700;
  }

  .entry-grey {
    background-color: #ececec;
  }

  .opacity-half {
    opacity: 0.5%;
  }

  .hoveredMember {
    background-color: #00A6D4 !important;
  }
</style>
